import { render, staticRenderFns } from "./VsIconButton.vue?vue&type=template&id=71d0fae2&lang=pug&"
import script from "./VsIconButton.vue?vue&type=script&lang=js&"
export * from "./VsIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d0fae2')) {
      api.createRecord('71d0fae2', component.options)
    } else {
      api.reload('71d0fae2', component.options)
    }
    module.hot.accept("./VsIconButton.vue?vue&type=template&id=71d0fae2&lang=pug&", function () {
      api.rerender('71d0fae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsIconButton.vue"
export default component.exports